module.exports = "/assets/data/ed976ba8611d2fe463aa4cd38070d3d2-SW15.data.json";